import React from 'react'
import { Button, Heading, Paragraph } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { useAPIGetRegistrationEntryLink } from '../../api/apiHooks/useAPIGetRegistrationEntryLink'
import { ResidentAppLocale } from '../../../common/validations'

import { Section } from 'components'

export const StrongAuthSection: React.FC = () => {
  const { t, i18n } = useTranslation('common')

  const { mutate, isPending } = useAPIGetRegistrationEntryLink(
    i18n.language ?? ResidentAppLocale.FI,
    false
  )

  const handleIdentify = () => {
    mutate(undefined, {
      onSuccess: (data) => {
        if (data.link) {
          window.location.assign(data.link)
        }
      },
    })
  }

  return (
    <Section divider>
      <Heading element="h2" size="l" className="font-medium mb-4">
        {t('userInfo.strongAuth.sectionHeader')}
      </Heading>

      <Paragraph className="mb-4">
        {t('userInfo.strongAuth.infoText')}
      </Paragraph>

      <div className="flex justify-end">
        <Button
          onClick={handleIdentify}
          type="button"
          loading={isPending}
          disabled={isPending}
        >
          {t('userInfo.strongAuth.authButton')}
        </Button>
      </div>
    </Section>
  )
}
